module.exports = __webpack_public_path__ + "img/06.c33db45e.png";